import { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactModal from '../components/ContactModal';
import Stats from '../components/landing/Stats';
import TrainingLevels from '../components/landing/TrainingLevels';
import TrainingTracks from '../components/landing/TrainingTracks';
import FlexibleTraining from '../components/landing/FlexibleTraining';
import FeaturedProducts from '../components/landing/FeaturedProducts';
import FeaturedBlogs from '../components/landing/FeaturedBlogs';

const Landing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="landing-page">
      <section className="hero-section">
        <div className="hero-content">
          <p className="hero-subtitle">WELCOME TO NAWIRI CHESS HOUSE</p>
          <h1 className="hero-title">
            Your One-stop Resource<br />
            For All Things Chess
          </h1>
          <p className="hero-description">
            Get trained by seasoned chess coaches, learn about upcoming events, and access chess gear all from one resource.
          </p>
          <div className="hero-buttons">
            <button
              className="btn btn-primary-hero"
              onClick={() => setIsModalOpen(true)}
            >
              Talk to a Trainer
            </button>
            <Link to="/events" className="btn btn-secondary-hero">
              View Events
            </Link>
          </div>
        </div>
      </section>

      <Stats />
      <TrainingLevels />
      <TrainingTracks />
      <FlexibleTraining />
      <FeaturedProducts />
      <FeaturedBlogs />

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Landing;
